module.exports = __webpack_public_path__ + "img/Dantam Makeover 12.513a6873.jpg";